import { Shield } from 'lucide-react';
import * as React from 'react';
import { useState } from 'react';
import { Link } from 'react-router';

import { CardHoverableGridPattern } from '@/components/card/card.hoverable-grid-pattern';
import { Button } from '@/components/ui/button';
import { TypographyH1New, TypographyMuted } from '@/components/ui/typography';

import { CalendlyModal } from '@/lib/calendly/calendly.modal';

export function SectionReadyToRelease() {
  const [open, setOpen] = useState(false);

  return (
    <section className="redesign-container border-b px-0">
      <CardHoverableGridPattern
        index={1}
        className="bg-background/20 border-0 pt-0 rounded-none"
      >
        <div className="p-8">
          <div className="max-w-3xl mx-auto text-center">
            <TypographyH1New className="mb-6 font-bold text-3xl lg:text-4xl">
              Ready to ship with confidence?
            </TypographyH1New>
            <TypographyMuted className="inline-flex items-center gap-2 mb-8 text-xl text-muted-foreground font-extralight">
              Get rolling with feature flags and A/B testing in minutes.
            </TypographyMuted>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <Button className="uppercase" size="lg" variant="glowing" asChild>
                <Link to="/register">Try FlagSync for Free</Link>
              </Button>
              <Button
                size="lg"
                className="uppercase"
                variant="outline-primary"
                onClick={() => setOpen(true)}
              >
                Get a Demo
              </Button>
              <CalendlyModal open={open} setOpen={setOpen} />
            </div>
            <TypographyMuted className="inline-flex items-center gap-1 mt-6 text-sm text-muted-foreground">
              <Shield className="size-4" />
              <span>No credit card required • Free 14-day trial</span>
            </TypographyMuted>
          </div>
        </div>
      </CardHoverableGridPattern>
    </section>
  );
}
